/**
 * Generated by orval v8.20.0.
 * Do not edit manually.
 * Hub API v2.0.0.
 */

import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import type {
  AgencyProvidersList200,
  AgencyProvidersUpdate200,
  AgencyProvidersUpdateBody,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
    | HttpParams
    | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class ProvidersService {
  private readonly http = inject(HttpClient);
  /**
   * Returns the session consumer's provider connections, ordered by provider name, each with the agency's own switch (`enabled`), the two switches that are ours and read-only here (`active` and `shopping_allowed`), and the consumer's IATA number, agency id and PCC for the provider. A provider can be shopped when it is `active`, `shopping_allowed` and `enabled`. Providers taken out of service platform-wide are left out. Unpaged, as a consumer connects to a screenful of providers. Managers of the agency only, sub-agency managers included.<br><br>Replaces `GET /v1.5/agent/account/airlines` of the legacy agent API: a list rather than a map keyed by provider code, which is `provider.agw_id`; `id` and `name` move under `provider`; `active`, the agency's switch, is `enabled`, and `active` is now the admin-side switch the legacy hid; `iata`, `agency_id` and `pcc` move under `identifiers`.
   * @summary List the consumer's providers
   */
  agencyProvidersList<TData = AgencyProvidersList200>(
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  agencyProvidersList<TData = AgencyProvidersList200>(
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  agencyProvidersList<TData = AgencyProvidersList200>(
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  agencyProvidersList<TData = AgencyProvidersList200>(
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${environment.hubApiUrl}/agency/providers`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${environment.hubApiUrl}/agency/providers`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${environment.hubApiUrl}/agency/providers`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Sets the agency's own switch on one of the session consumer's provider connections and returns the connection. It leaves `active` and `shopping_allowed` alone: those are ours to set, and an agency turning a provider back on must not undo a decision made from the admin console. Idempotent: setting the state the switch already has answers 200 with the connection. A provider taken out of service platform-wide is not found, as it is not listed. Managers of the consumer's super agency only: the switch is the consumer's, so turning a provider off here turns it off for every agency of the consumer, and a sub-agency's manager sees the screen read-only.<br><br>Replaces `POST /v1.5/agent/account/airlines` of the legacy agent API: one provider per request rather than the whole map, sent as `enabled` in place of `active`; the reply is the connection; and sub-agency managers, whom the legacy let through, are refused.
   * @summary Turn a provider on or off for the consumer
   */
  agencyProvidersUpdate<TData = AgencyProvidersUpdate200>(
    providerId: string,
    agencyProvidersUpdateBody: AgencyProvidersUpdateBody,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  agencyProvidersUpdate<TData = AgencyProvidersUpdate200>(
    providerId: string,
    agencyProvidersUpdateBody: AgencyProvidersUpdateBody,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  agencyProvidersUpdate<TData = AgencyProvidersUpdate200>(
    providerId: string,
    agencyProvidersUpdateBody: AgencyProvidersUpdateBody,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  agencyProvidersUpdate<TData = AgencyProvidersUpdate200>(
    providerId: string,
    agencyProvidersUpdateBody: AgencyProvidersUpdateBody,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
        `${environment.hubApiUrl}/agency/providers/${providerId}`,
        agencyProvidersUpdateBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
        `${environment.hubApiUrl}/agency/providers/${providerId}`,
        agencyProvidersUpdateBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.patch<TData>(
      `${environment.hubApiUrl}/agency/providers/${providerId}`,
      agencyProvidersUpdateBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
}
